export { PricingCard } from "./PricingCard";
export { CurrencySelector } from "./CurrencySelector";
export { PricingFAQ } from "./PricingFAQ";

export type Currency = "USD" | "GBP" | "EUR";

export const currencySymbols: Record<Currency, string> = {
  USD: "$",
  GBP: "£",
  EUR: "€",
};

export const exchangeRates: Record<Currency, number> = {
  USD: 1,
  GBP: 0.79,
  EUR: 0.93,
};
